import { render, staticRenderFns } from "./DeliverySpeed.vue?vue&type=template&id=54900582&scoped=true"
import script from "./DeliverySpeed.vue?vue&type=script&lang=js"
export * from "./DeliverySpeed.vue?vue&type=script&lang=js"
import style0 from "./DeliverySpeed.vue?vue&type=style&index=0&id=54900582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54900582",
  null
  
)

export default component.exports